import { CONF } from '@/assets/js/config'
import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  //数据源
  state: {
    ulang:CONF.LANG,
    lang:{},
    langTypes:[],
	userInfo:{},
	params:{},
	siteName:{},
    kefu:'',
    staffInfo:{},
    appDownLoad:'',
	  translateData:'',
	  configData:'',
  },
  mutations: {
    SET_USERINFO(state,userInfo){
		state.userInfo = userInfo
	},
    SET_TRANSLATE(state,translateData){
		state.translateData = translateData
		state.lang = translateData
	},
    SET_CONFIGDATA(state,configData){
		state.configData = configData
	},

    SET_ULANG(state,ulang){
		state.ulang = ulang
	},
	SET_PARAMS(state,params){
		state.params = params
	},
	SET_SITENAME(state,siteName){
		state.siteName = siteName
	},
    SET_LANGTYPES(state,langTypes){
			state.langTypes = langTypes
		},
    SET_STAFFINFO(state,staffInfo){
			state.staffInfo = staffInfo
		},
    SET_APPDOWNLOAD(state,appDownLoad){
			state.appDownLoad = appDownLoad
		},
    SET_KEFU(state,kefu){
		state.kefu = kefu
	},
	CLEAR_USERINFO(state){
		state.userInfo = {}
	},
    CLEAR_ULANG(state){
		state.ulang = ''
	},

  },
  actions: {
    set_userInfo({commit},userInfo){
		commit("SET_USERINFO",userInfo)
	},
    set_ulang({commit},ulang){
		commit('SET_ULANG',ulang)
	},			
	set_lang({commit},lang){
		commit('SET_LANG',lang)
	},
	set_params({commit},params){
		commit("SET_PARAMS",params)
	},
    set_langTypes({commit},langTypes){
		commit("SET_LANGTYPES",langTypes)
	},
	set_siteName({commit},siteName){
		commit("SET_SITENAME",siteName)
	},
    set_siteKefu({commit},kefu){
		commit("SET_KEFU",kefu)
	},
    set_appDownLoad({commit},appDownLoad){
		commit("SET_APPDOWNLOAD",appDownLoad)
	},
	clear_userInfo({commit}){
		commit('CLEAR_USERINFO')
	},
    clear_ulang({commit}){
		commit('CLEAR_ULANG')
	},
	clear_lang({commit}){
		commit('CLEAR_LANG')
	},
    set_staffInfo({commit},staffInfo){
		commit("SET_STAFFINFO",staffInfo)
	}
  },
  plugins: [
    persistedState()
  ]
})

export default store